/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {Error} from '../models/Error';
import type {UserWorkspaceSettingsSaveRequest} from '../models/UserWorkspaceSettingsSaveRequest';
import type {WorkspaceSettings} from '../models/WorkspaceSettings';

export interface GetUserWorkspaceSettings$Request {
    userId: number;
}

export interface GetUserWorkspaceSettings$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getUserWorkspaceSettingsRequest = createAction<PayloadData<void, GetUserWorkspaceSettings$Request>>('USERS_WORKSPACE_SETTINGS__GET_USER_WORKSPACE_SETTINGS__REQUEST');
export const getUserWorkspaceSettingsSuccess = createAction<PayloadData<WorkspaceSettings, GetUserWorkspaceSettings$Request>>('USERS_WORKSPACE_SETTINGS__GET_USER_WORKSPACE_SETTINGS__SUCCESS');
export const getUserWorkspaceSettingsFailure = createAction<PayloadData<Error, GetUserWorkspaceSettings$Request, true>>('USERS_WORKSPACE_SETTINGS__GET_USER_WORKSPACE_SETTINGS__FAILURE');

export const getUserWorkspaceSettingsActions = [
    getUserWorkspaceSettingsRequest,
    getUserWorkspaceSettingsSuccess,
    getUserWorkspaceSettingsFailure
] as const;

/**
 * @param {number} meta.userId
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getUserWorkspaceSettings = (meta: GetUserWorkspaceSettings$Request, config?: GetUserWorkspaceSettings$Config) => {
    return {
        CALL_API: {
            types: getUserWorkspaceSettingsActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/users/${meta.userId}/workspace-settings`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface SetUserWorkspaceSettings$Request {
    userId: number;
    userWorkspaceSettingsSaveRequest: UserWorkspaceSettingsSaveRequest;
}

export interface SetUserWorkspaceSettings$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const setUserWorkspaceSettingsRequest = createAction<PayloadData<void, SetUserWorkspaceSettings$Request>>('USERS_WORKSPACE_SETTINGS__SET_USER_WORKSPACE_SETTINGS__REQUEST');
export const setUserWorkspaceSettingsSuccess = createAction<PayloadData<void, SetUserWorkspaceSettings$Request>>('USERS_WORKSPACE_SETTINGS__SET_USER_WORKSPACE_SETTINGS__SUCCESS');
export const setUserWorkspaceSettingsFailure = createAction<PayloadData<Error, SetUserWorkspaceSettings$Request, true>>('USERS_WORKSPACE_SETTINGS__SET_USER_WORKSPACE_SETTINGS__FAILURE');

export const setUserWorkspaceSettingsActions = [
    setUserWorkspaceSettingsRequest,
    setUserWorkspaceSettingsSuccess,
    setUserWorkspaceSettingsFailure
] as const;

/**
 * @param {number} meta.userId
 * @param {UserWorkspaceSettingsSaveRequest} meta.userWorkspaceSettingsSaveRequest
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const setUserWorkspaceSettings = (meta: SetUserWorkspaceSettings$Request, config?: SetUserWorkspaceSettings$Config) => {
    return {
        CALL_API: {
            types: setUserWorkspaceSettingsActions,
            method: ApiMethods.PUT,
            endpoint: `/web-api/users/${meta.userId}/workspace-settings`,
            TRANSPORT_REQUEST_BODY: meta.userWorkspaceSettingsSaveRequest,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

